import React, { useState, useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Landing from './pages/Landing'
import Login from './pages/Login'
import Register from './pages/Register'
import Dashboard from './pages/Dashboard'
import DeviceDetail from './pages/DeviceDetail'
import Verify from './pages/Verify'
import Support from './pages/Support'
import Changelog from './pages/Changelog'
import Order from './pages/Order'
import NotificationHistory from './pages/NotificationHistory'
import Settings from './pages/Settings'
import Admin from './pages/Admin'
import ForgotPassword from './pages/ForgotPassword'
import AlertAction from './pages/AlertAction'
import ResetPassword from './pages/ResetPassword'
import ShareAccept from './pages/ShareAccept'
import Privacy from './pages/Privacy'
import Terms from './pages/Terms'
import Profile from './pages/Profile'
import SmsCredits from './pages/SmsCredits'
function PrivateRoute({ children }: { children: React.ReactNode }) {
  const token = localStorage.getItem('token') ||
    document.cookie.split(';').find(c => c.trim().startsWith('token='))?.split('=')[1]
  return token ? <>{children}</> : <Navigate to="/login" />
}

async function fetchBuildTime(): Promise<string | null> {
  try {
    const res = await fetch('/version.json?t=' + Date.now())
    const data = await res.json()
    return data.buildTime ?? null
  } catch {
    return null
  }
}

function UpdateBanner() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    let loadedBuildTime: string | null = null

    fetchBuildTime().then(t => { loadedBuildTime = t })

    const interval = setInterval(async () => {
      const current = await fetchBuildTime()
      if (current && loadedBuildTime && current !== loadedBuildTime) {
        setVisible(true)
      }
    }, 60 * 1000)

    return () => clearInterval(interval)
  }, [])

  if (!visible) return null

  return (
    <div style={{
      position: 'fixed', bottom: 20, left: '50%', transform: 'translateX(-50%)',
      backgroundColor: '#1a1a1a', color: '#fff', borderRadius: 14,
      padding: '12px 18px', display: 'flex', alignItems: 'center', gap: 14,
      boxShadow: '0 4px 20px rgba(0,0,0,0.25)', zIndex: 9999,
      fontFamily: "'Inter', -apple-system, sans-serif", fontSize: 14,
      whiteSpace: 'nowrap'
    }}>
      <span>Nová verzia je dostupná</span>
      <button
        onClick={() => window.location.reload()}
        style={{
          backgroundColor: '#2D7A3A', color: '#fff', border: 'none',
          borderRadius: 8, padding: '7px 14px', fontSize: 13, fontWeight: 600,
          cursor: 'pointer', fontFamily: 'inherit'
        }}
      >
        Aktualizovať
      </button>
      <button
        onClick={() => setVisible(false)}
        style={{ background: 'none', border: 'none', color: '#9ca3af', cursor: 'pointer', fontSize: 18, lineHeight: 1, padding: 0 }}
      >
        ×
      </button>
    </div>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <UpdateBanner />
      <Routes>
        <Route path="/" element={
          window.matchMedia('(display-mode: standalone)').matches || (window.navigator as any).standalone
            ? (localStorage.getItem('token') ? <Navigate to="/dashboard" /> : <Navigate to="/login" />)
            : <Landing />
        } />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify" element={<Verify />} />
        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/device/:id" element={<PrivateRoute><DeviceDetail /></PrivateRoute>} />
        <Route path="/support" element={<Support />} />
        <Route path="/changelog" element={<Changelog />} />
        <Route path="/order" element={<Order />} />
        <Route path="/notifications" element={<PrivateRoute><NotificationHistory /></PrivateRoute>} />
        <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
        <Route path="/admin" element={<PrivateRoute><Admin /></PrivateRoute>} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/share/accept" element={<PrivateRoute><ShareAccept /></PrivateRoute>} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
        <Route path="/sms-credits" element={<PrivateRoute><SmsCredits /></PrivateRoute>} />
        <Route path="/alert/:deviceId" element={<PrivateRoute><AlertAction /></PrivateRoute>} />
      </Routes>
    </BrowserRouter>
  )
}
